import { ReactNode } from "react";
import { RiCheckboxCircleFill } from "@remixicon/react";


export function CheckedFeature(
  {
    children,
  }: {
    children: ReactNode;
  }
) {
  return (
    <div className="flex flex-row gap-x-2">
      <RiCheckboxCircleFill className="size-5 text-success-600"/>
      <span>{ children }</span>
    </div>
  );
}
